var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _c("member-header", { on: { cancel: _vm.cancelDialogHandle } }),
      _vm._v(" "),
      _c("div", { attrs: { id: "member_main" } }, [
        _c(
          "main",
          [
            _c(
              "transition",
              { attrs: { name: "page", mode: "out-in" } },
              [_c("router-view")],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "お申込みのキャンセル",
            visible: _vm.cancelDialog,
            width: "80%"
          },
          on: {
            "update:visible": function($event) {
              _vm.cancelDialog = $event
            }
          }
        },
        [
          _c("span", [_vm._v("お申込みをキャンセルしてよろしいでしょうか？")]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.cancelDialog = false
                    }
                  }
                },
                [_vm._v("戻る")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "danger" },
                  on: { click: _vm.nextCancelPage }
                },
                [_vm._v("キャンセルする")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }